// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spacer":"Spacer__spacer"};